import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

const HealthPage = lazy(() => import("@/pages/Health"));

export const Route = createFileRoute("/health/")({
  component: HealthRoute,
});

function HealthRoute() {
  return (
    <ProtectedRoute>
      <Layout>
        <Suspense fallback={null}>
          <HealthPage />
        </Suspense>
      </Layout>
    </ProtectedRoute>
  );
}
